var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacuumCleaner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vacuum-cleaner",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.8333 20.625C23.8333 20.625 23.8333 11.9166 23.8333 9.16663C23.8333 6.41663 25.6666 3.66663 29.3333 3.66663C32.9999 3.66663 34.8333 6.41663 34.8333 9.16663C34.8333 11.9166 34.8333 31.1666 34.8333 31.1666",
    stroke: "url(#paint0_linear_1248_586)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.0208 31.1667H39.6458L40.3333 36.6667H29.3333L30.0208 31.1667Z",
    stroke: "url(#paint1_linear_1248_586)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.16675 36.6666H23.7293C23.7868 36.6666 23.8334 36.62 23.8334 36.5625V21.3167C23.8334 14.6064 18.3936 9.16663 11.6834 9.16663C8.77467 9.16663 6.41675 11.5246 6.41675 14.4332V26.5833",
    stroke: "url(#paint2_linear_1248_586)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.16675 36.6666C12.2043 36.6666 14.6667 34.2042 14.6667 31.1666C14.6667 28.1291 12.2043 25.6666 9.16675 25.6666C6.12918 25.6666 3.66675 28.1291 3.66675 31.1666C3.66675 34.2042 6.12918 36.6666 9.16675 36.6666Z",
    stroke: "url(#paint3_linear_1248_586)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.8333 9.16663V26.5833",
    stroke: "url(#paint4_linear_1248_586)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_586",
    x1: 27.8454,
    y1: -2.17064,
    x2: 39.1325,
    y2: -0.267113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1248_586",
    x1: 33.3454,
    y1: 29.9993,
    x2: 40.1297,
    y2: 35.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1248_586",
    x1: 12.7693,
    y1: 3.32936,
    x2: 29.9257,
    y2: 7.91048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1248_586",
    x1: 7.67891,
    y1: 23.3317,
    x2: 17.5351,
    y2: 27.4872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1248_586",
    x1: 13.198,
    y1: 5.46969,
    x2: 14.2527,
    y2: 5.49522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacuumCleaner);
export default __webpack_public_path__ + "static/media/vacuum-cleaner.ccbae06d69b932632f3a858829c56263.svg";
export { ForwardRef as ReactComponent };